import { AddressingResultActionTypes } from "../constants/addressingResultActionTypes";
const initialState = {
  candidates: [],
  loading: false,
  error: "",
  fetchType: "", //fetch_type can be -Suggestion_Select , Text_Search , Map_Click,
  fetchInput: "", //will be magickey / user search text / map Point user clicked on map
};

export const addressingResultReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case AddressingResultActionTypes.FETCH_AddressResults_REQUEST:
      return {
        ...state,
        candidates: [],
        loading: true,
        fetchType: payload.fetchType,
        fetchInput: payload.fetchInput,
      };

    case AddressingResultActionTypes.FETCH_AddressResults_FAILURE:
      return {
        ...state,
        loading: false,
        candidates: [],
        error: payload,
      };

    case AddressingResultActionTypes.FETCH_AddressResults_SUCCESS:
      return {
        ...state,
        candidates: payload,
        error: "",
        loading: false,
      };
    case AddressingResultActionTypes.FETCH_AddressResults_SUCCESS:
      return {
        ...state,
        candidates: payload,
        error: "",
        loading: false,
      };
    case AddressingResultActionTypes.FETCH_DATA_FROM_COOKIES:
      return {
        ...state,
        candidates: payload.candidates,
        loading: payload.loading,
        fetchType: payload.fetchType,
        fetchInput: payload.fetchInput,
      };

    case AddressingResultActionTypes.CLEAR_AddressResults:
      return initialState;

    default:
      return state;
  }
};
